import { deepCopy, removeEmptyField } from '@/utils/objectHelper'
import { isString } from '@/utils/stringHelper'
import moment from 'moment'

export const formatOffer = (data) => {
  //Remove Unnecessary field and clean empty field
  const offer = deepCopy(data)
  // delete offer.updatedAt;
  delete offer.status
  delete offer.id
  delete offer._id
  delete offer.history
  delete offer.damexCreateDate
  delete offer.confirmDamexTime
  // delete offer?.booking?.handoverForm?.handoverConfirmedDate
  // delete offer?.booking?.handoverForm?.handoverConfirmedBy

  if (offer?.customer && offer?.customer?._id) {
    offer.customer = offer.customer._id
  }

  if (offer?.customer === '') {
    delete offer.customer
  }
  if (offer?.contributors) {
    offer.contributors
      .filter((contributorDetail) => !!contributorDetail)
      .forEach((contributorDetail) => {
        delete contributorDetail.status

        if (contributorDetail?.attachments) {
          contributorDetail.attachments = contributorDetail.attachments
            .map((file) => file?._id || '')
            .filter((file) => file !== '')
        }

        if (contributorDetail?.user?._id != undefined && contributorDetail?.user?._id !== '') {
          const userId = contributorDetail.user._id
          delete contributorDetail['user._id']
          delete contributorDetail['user.email']
          contributorDetail.user = userId
        } else if (!isString(contributorDetail?.user) || contributorDetail?.user === '') {
          contributorDetail.user = null
        }
      })
  }

  if (offer?.optionalContributors) {
    offer.optionalContributors
      .filter((contributorDetail) => !!contributorDetail)
      .forEach((contributorDetail) => {
        delete contributorDetail.status

        if (contributorDetail?.attachments) {
          contributorDetail.attachments = contributorDetail.attachments
            .map((file) => file?._id || '')
            .filter((file) => file !== '')
        }

        if (contributorDetail?.user?._id != undefined && contributorDetail?.user?._id !== '') {
          const userId = contributorDetail.user._id
          delete contributorDetail['user._id']
          delete contributorDetail['user.email']
          contributorDetail.user = userId
        } else if (!isString(contributorDetail?.user) || contributorDetail?.user === '') {
          contributorDetail.user = null
        }
      })
  }
  if (offer?.approvers) {
    offer.approvers
      .filter((approverDetail) => !!approverDetail)
      .forEach((approverDetail) => {
        if (approverDetail?.attachments) {
          approverDetail.attachments = approverDetail.attachments
            .map((file) => file?._id || '')
            .filter((file) => file !== '')
        }
        if (approverDetail?.user?._id != undefined && approverDetail?.user?._id !== '') {
          const userId = approverDetail.user._id

          delete approverDetail['user._id']
          delete approverDetail['user.email']
          approverDetail.user = userId
        } else if (!isString(approverDetail?.user) || approverDetail?.user === '') {
          approverDetail.user = null
        }

        if (Array.isArray(approverDetail.invitedUsers)) {
          approverDetail.invitedUsers.forEach((inviteeDetail) => {
            if (inviteeDetail?.user?._id) {
              inviteeDetail.user = inviteeDetail?.user?._id
            }

            if (Array.isArray(inviteeDetail?.files)) {
              inviteeDetail.files = inviteeDetail.files.map((file) => file?._id || file).filter((id) => id)
            }

            if (Array.isArray(inviteeDetail?.replyFiles)) {
              inviteeDetail.replyFiles = inviteeDetail.replyFiles.map((file) => file?._id || file).filter((id) => id)
            }
          })
        }

        if (approverDetail?.lastActionUser?._id) {
          approverDetail.lastActionUser = approverDetail.lastActionUser._id
        }

        if (approverDetail?.delegationDetail?._id) {
          approverDetail.delegationDetail = approverDetail.delegationDetail._id
        }
      })
  }

  if (offer?.subSystems) {
    offer.subSystems.forEach((subSystem) => {
      if (Array.isArray(subSystem?.PM040GCMaterials)) {
        subSystem.PM040GCMaterials = subSystem.PM040GCMaterials.map((gcMaterial) => {
          return {
            ...gcMaterial,
            detail: gcMaterial?.detail?.id || gcMaterial?.detail,
            allDetails: gcMaterial?.allDetails?.map((detail) => detail?.id || detail) || [],
          }
        })
      }

      if (Array.isArray(subSystem?.PM100GCMaterials)) {
        subSystem.PM100GCMaterials = subSystem.PM100GCMaterials.map((gcMaterial) => {
          return {
            ...gcMaterial,
            detail: gcMaterial?.detail?.id || gcMaterial?.detail,
            allDetails: gcMaterial?.allDetails?.map((detail) => detail?.id || detail) || [],
          }
        })
      }

      if (subSystem?.profitCenter?._id) {
        subSystem.profitCenter = subSystem.profitCenter._id
      }
      if (subSystem?.GCKCode === '') {
        //Set to NIL
        subSystem.GCKCode = undefined
      }

      //  //Internal CostSheet
      if (subSystem?.internalCostSheet && subSystem?.internalCostSheet.length > 0) {
        subSystem.internalCostSheet = subSystem.internalCostSheet.map((docObj) => docObj?._id || docObj)
      }
      if (subSystem?.bookingCostSheet && subSystem?.bookingCostSheet.length > 0) {
        subSystem.bookingCostSheet = subSystem.bookingCostSheet.map((docObj) => docObj?._id || docObj)
      }

      if (subSystem.type === 'maintenance') {
        if (subSystem.newOrRenewal === 'new') {
          delete subSystem.existingWBSNumber
        } else if (subSystem.newOrRenewal === 'renewal') {
          delete subSystem.conversionRate
          delete subSystem.projectWBS
          delete subSystem.projectValue
        } else if (subSystem.newOrRenewal === 'renewalOfDiscontinued') {
          delete subSystem.conversionRate
          delete subSystem.projectWBS
          delete subSystem.projectValue
        }
      } else if (subSystem.type === 'project') {
        delete subSystem.newOrRenewal
        delete subSystem.conversionRate
        delete subSystem.projectWBS
        delete subSystem.projectValue
        delete subSystem.existingWBSNumber
      }
    })
  }

  // COMMERCIAL CHECKLIST
  if (offer?.commercialChecklist) {
    // Update All 'other' option text
    offer.commercialChecklist = removeEmptyField(offer.commercialChecklist)
    // Object.entries(offer.commercialChecklist).forEach(([key, value]) => {
    //   if (!value || value === '' || (_.has(value, 'value') && !value.value)) {
    //     delete offer.commercialChecklist[key];
    //   }
    // });
  }

  if (offer.documents) {
    Object.keys(offer.documents).forEach((documentType) => {
      const multipleDocuments = offer.documents[documentType]

      switch (documentType) {
        case 'internalCostsheet':
        case 'internalOthers':
        case 'externalOthers':
        case 'tenderQueries':
          multipleDocuments.forEach((documents, docIndex) => {
            if (offer.documents[documentType][docIndex].files) {
              offer.documents[documentType][docIndex].files = offer.documents[documentType][docIndex].files.map(
                (docObj) => docObj?._id || docObj
              )
            } else {
              offer.documents[documentType][docIndex].files = []
            }
          })
          break
        default:
          // Reudce The Populated Offer Document to DocId
          if (offer.documents[documentType]) {
            offer.documents[documentType] = offer.documents[documentType].map((docObj) => docObj?._id || docObj)
          }
          break
      }
    })
  }

  // SOURCING

  if (offer?.sourcing?.sourcingDueDate === null) {
    delete offer?.sourcing?.sourcingDueDate
  }

  if (offer?.sourcing) {
    const threshold = offer.sourcing.sourcingThreshold
    const isInvalid =
      threshold === null ||
      threshold === undefined ||
      threshold === '' ||
      threshold === 'NaN' ||
      threshold === 'null' ||
      (typeof threshold === 'number' && (isNaN(threshold) || !isFinite(threshold))) ||
      (typeof threshold === 'string' && threshold.trim() !== '' && isNaN(Number(threshold)))

    if (isInvalid) {
      delete offer.sourcing.sourcingThreshold
    } else if (typeof threshold === 'string' && threshold.trim() !== '') {
      const numValue = Number(threshold)
      if (!isNaN(numValue) && isFinite(numValue)) {
        offer.sourcing.sourcingThreshold = numValue
      } else {
        delete offer.sourcing.sourcingThreshold
      }
    }
  }

  if (Array.isArray(offer?.sourcing?.costBudgets)) {
    offer.sourcing.costBudgets.forEach((costBudget) => {
      //Format PM040, PM100 Selection

      if (costBudget.firstTechnicalSelection.vendor === 'reference') {
        costBudget.firstTechnicalSelection.vendor = null
        costBudget.firstTechnicalSelection.uploadHistoryIndex = -1
        costBudget.firstTechnicalSelection.isReference = true
      } else {
        costBudget.firstTechnicalSelection.isReference = false
      }
      if (costBudget?.dueDate === null) {
        //Can't set empty due date
        delete costBudget.dueDate
      }
      const costBudgetDetail = costBudget?.detail
      if (!costBudgetDetail) {
        return
      }

      costBudgetDetail.subcontractors.forEach((subcontractor) => {
        subcontractor?.history.forEach((his) => {
          if (his?.uploader?._id) {
            const uploaderId = his?.uploader?._id
            his.uploader = uploaderId
          }
        })

        if (subcontractor.category === '') {
          subcontractor.category = undefined
        }
        if (subcontractor.vendor === '') {
          subcontractor.vendor = undefined
        }

        if (Array.isArray(subcontractor?.emailLogs)) {
          subcontractor?.emailLogs.forEach((log) => {
            if (log?.sender?._id) {
              const senderId = log?.sender?._id
              log.sender = senderId
            }

            if (log?.files && Array.isArray(log.files)) {
              const allFileIds = []
              log.files.forEach((file) => {
                if (!file?._id) {
                  return
                }

                //Cast Object to _id only
                allFileIds.push(file._id)
              })

              log.files = allFileIds
            }
          })
        }
      })

      if (costBudgetDetail.internalDocuments) {
        costBudgetDetail.internalDocuments = costBudgetDetail.internalDocuments.map((docObj) => docObj?._id || docObj)
      }
      if (costBudgetDetail.annex1) {
        costBudgetDetail.annex1 = costBudgetDetail.annex1.map((docObj) => docObj?._id || docObj)
      }
      if (costBudgetDetail.annex2) {
        costBudgetDetail.annex2 = costBudgetDetail.annex2.map((docObj) => docObj?._id || docObj)
      }
      if (costBudgetDetail.annex3) {
        costBudgetDetail.annex3 = costBudgetDetail.annex3.map((docObj) => docObj?._id || docObj)
      }

      if (Array.isArray(costBudget?.PR?.vendorSelections)) {
        costBudget.PR.vendorSelections.forEach((vendorSelection) => {
          if (Array.isArray(vendorSelection?.submissions)) {
            vendorSelection.submissions.forEach((submission) => {
              if (Array.isArray(submission?.internalDocument)) {
                submission.internalDocument = submission.internalDocument.map((docObj) => docObj?._id || docObj)
              }
              if (Array.isArray(submission?.subcontractorAgreement)) {
                submission.subcontractorAgreement = submission.subcontractorAgreement.map(
                  (docObj) => docObj?._id || docObj
                )
              }

              if (Array.isArray(submission?.requiredWorkInstructionAttachments)) {
                submission.requiredWorkInstructionAttachments = submission.requiredWorkInstructionAttachments.map(
                  (docObj) => docObj?._id || docObj
                )
              }

              if (Array.isArray(submission?.history)) {
                submission.history.forEach((historyEntry) => {
                  if (Array.isArray(historyEntry?.files)) {
                    historyEntry.files = historyEntry.files.map((file) => file?._id || file).filter((id) => id)
                  }

                  if (historyEntry?.createdBy?._id) {
                    historyEntry.createdBy = historyEntry.createdBy._id
                  }
                })
              }

              if (Array.isArray(submission?.approverDetails)) {
                submission.approverDetails.forEach((approverDetail) => {
                  if (approverDetail?.user?._id) {
                    approverDetail.user = approverDetail.user._id
                  }

                  if (Array.isArray(approverDetail?.attachments)) {
                    approverDetail.attachments = approverDetail.attachments
                      .map((file) => file?._id || file)
                      .filter((id) => id)
                  }

                  if (Array.isArray(approverDetail?.invitedUsers)) {
                    approverDetail.invitedUsers.forEach((inviteeDetail) => {
                      if (inviteeDetail?.user?._id) {
                        inviteeDetail.user = inviteeDetail?.user?._id
                      }

                      if (Array.isArray(inviteeDetail?.files)) {
                        inviteeDetail.files = inviteeDetail.files.map((file) => file?._id || file).filter((id) => id)
                      }

                      if (Array.isArray(inviteeDetail?.replyFiles)) {
                        inviteeDetail.replyFiles = inviteeDetail.replyFiles
                          .map((file) => file?._id || file)
                          .filter((id) => id)
                      }
                    })
                  }
                  if (approverDetail?.delegationDetail?._id) {
                    approverDetail.delegationDetail = approverDetail.delegationDetail._id
                  }
                })
              }
            })
          }
        })
      }
    })
  }

  if (offer?.sourcing?.procurementOfficer === '') {
    delete offer.sourcing.procurementOfficer
  }

  if (Array.isArray(offer?.sourcing?.projectExecutionGCMaterialDetails)) {
    offer.sourcing.projectExecutionGCMaterialDetails.forEach((projectExecutionDetail) => {
      if (projectExecutionDetail?.detail?.id) {
        projectExecutionDetail.detail = projectExecutionDetail.detail.id
      }
      if (projectExecutionDetail?.detail?._id) {
        projectExecutionDetail.detail = projectExecutionDetail.detail._id
      }
      if (Array.isArray(projectExecutionDetail.allDetails)) {
        projectExecutionDetail.allDetails = projectExecutionDetail.allDetails.map((d) => d?.id || d?._id || d)
      }
    })
  }

  if (Array.isArray(offer?.sourcing?.GCMaterialSubmissions)) {
    offer.sourcing.GCMaterialSubmissions.forEach((gcMaterialSubmission) => {
      if (gcMaterialSubmission?.raiser?._id) {
        gcMaterialSubmission.raiser = gcMaterialSubmission.raiser._id
      }
      if (gcMaterialSubmission?.requestor?._id) {
        gcMaterialSubmission.requestor = gcMaterialSubmission.requestor._id
      }

      if (Array.isArray(gcMaterialSubmission?.approverDetails)) {
        gcMaterialSubmission.approverDetails.forEach((approverDetail) => {
          if (approverDetail?.user?._id) {
            approverDetail.user = approverDetail.user._id
          }

          if (approverDetail?.delegationDetail?._id) {
            approverDetail.delegationDetail = approverDetail.delegationDetail._id
          }

          if (Array.isArray(approverDetail?.attachments)) {
            approverDetail.attachments = approverDetail.attachments.map((file) => file?._id || file).filter((id) => id)
          }

          if (Array.isArray(approverDetail?.invitedUsers)) {
            approverDetail.invitedUsers.forEach((inviteeDetail) => {
              if (inviteeDetail?.user?._id) {
                inviteeDetail.user = inviteeDetail.user._id
              }

              if (Array.isArray(inviteeDetail?.files)) {
                inviteeDetail.files = inviteeDetail.files.map((file) => file?._id || file).filter((id) => id)
              }

              if (Array.isArray(inviteeDetail?.replyFiles)) {
                inviteeDetail.replyFiles = inviteeDetail.replyFiles.map((file) => file?._id || file).filter((id) => id)
              }
            })
          }
        })
      }

      if (gcMaterialSubmission?.filledBuyNow?.id) {
        gcMaterialSubmission.filledBuyNow = gcMaterialSubmission.filledBuyNow.id
      }
      if (gcMaterialSubmission?.filledBuyNow?._id) {
        gcMaterialSubmission.filledBuyNow = gcMaterialSubmission.filledBuyNow._id
      }

      if (Array.isArray(gcMaterialSubmission.internalDocument)) {
        gcMaterialSubmission.internalDocument = gcMaterialSubmission.internalDocument.map(
          (doc) => doc?.id || doc?._id || doc
        )
      }

      if (Array.isArray(gcMaterialSubmission.licenseFile)) {
        gcMaterialSubmission.licenseFile = gcMaterialSubmission.licenseFile.map((doc) => doc?.id || doc?._id || doc)
      }

      gcMaterialSubmission.requestedDetails.forEach((requestorDetail) => {
        if (requestorDetail?.detail?.id) {
          requestorDetail.detail = requestorDetail.detail.id
        }
        if (requestorDetail?.detail?._id) {
          requestorDetail.detail = requestorDetail.detail._id
        }
        if (Array.isArray(requestorDetail.allDetails)) {
          requestorDetail.allDetails = requestorDetail.allDetails.map((d) => d?.id || d?._id || d)
        }
      })
    })
  }

  if (offer?.booking?.projectManager?._id) {
    offer.booking.projectManager = offer.booking.projectManager._id
  }
  if (offer?.booking?.approverDetails) {
    offer.booking.approverDetails.forEach((approverDetail) => {
      if (approverDetail?.attachments) {
        approverDetail.attachments = approverDetail.attachments
          .map((file) => file?._id || '')
          .filter((file) => file !== '')
      }

      if (Array.isArray(approverDetail.invitedUsers)) {
        approverDetail.invitedUsers.forEach((inviteeDetail) => {
          if (inviteeDetail?.user?._id) {
            inviteeDetail.user = inviteeDetail?.user?._id
          }
        })
      }
      if (approverDetail?.user && approverDetail.user?._id) {
        const userId = approverDetail.user._id
        approverDetail.user = userId
        return
      }
      approverDetail.user = undefined
    })
  }

  if (offer?.manager === '') {
    delete offer.manager
  }

  if (offer?.booking?.teamAssistant === '') {
    delete offer.booking.teamAssistant
  }

  // if (offer?.booking?.handoverForm?.documentDetail && offer.booking.handoverFormDetail) {
  //   offer.booking.handoverForm.documentDetail = offer.booking.handoverFormDetail.flat().map((doc) => ({
  //     name: doc.name || '',
  //     genre: doc.genre || '',
  //     key: doc.key || '',
  //     isAvailable: doc.isAvailable || false,
  //     availableDate:
  //       doc.availableDate && moment(doc.availableDate).isSame(moment('1970-01-01T00:00:00Z'))
  //         ? undefined
  //         : doc.availableDate
  //           ? doc.availableDate
  //           : undefined,
  //     remark: doc.remark || '',
  //     link: Array.isArray(doc.link) ? doc.link[0] : doc.link || '',
  //     isOthers: doc.isOthers || false,
  //   }))
  //   delete offer.booking.handoverFormDetail
  // }

  if (offer?.booking?.confirmationDocument) {
    offer.booking.confirmationDocument = offer?.booking?.confirmationDocument.map((doc) => doc?._id || doc)
  }

  if (offer?.booking?.commercialChecklist?.paymentTerms?.attachments) {
    offer.booking.commercialChecklist.paymentTerms.attachments =
      offer?.booking?.commercialChecklist?.paymentTerms?.attachments.map((doc) => doc?._id || doc)
  }
  if (offer?.booking?.commercialChecklist?.requireBond?.attachments) {
    offer.booking.commercialChecklist.requireBond.attachments =
      offer?.booking?.commercialChecklist?.requireBond?.attachments.map((doc) => doc?._id || doc)
  }
  if (offer?.booking?.commercialChecklist?.insurance?.attachments) {
    offer.booking.commercialChecklist.insurance.attachments =
      offer?.booking?.commercialChecklist?.insurance?.attachments.map((doc) => doc?._id || doc)
  }
  if (offer?.booking?.commercialChecklist?.openAccountForEPD?.attachments) {
    offer.booking.commercialChecklist.openAccountForEPD.attachments =
      offer?.booking?.commercialChecklist?.openAccountForEPD?.attachments.map((doc) => doc?._id || doc)
  }
  if (offer?.booking?.commercialChecklist?.declareInCIC?.attachments) {
    offer.booking.commercialChecklist.declareInCIC.attachments =
      offer?.booking?.commercialChecklist?.declareInCIC?.attachments.map((doc) => doc?._id || doc)
  }
  if (offer?.booking?.commercialChecklist?.assignmentConsent?.attachments) {
    offer.booking.commercialChecklist.assignmentConsent.attachments =
      offer?.booking?.commercialChecklist?.assignmentConsent?.attachments.map((doc) => doc?._id || doc)
  }

  if (Array.isArray(offer?.booking?.commercialChecklist?.other)) {
    offer?.booking?.commercialChecklist?.other.forEach((otherCommercialItem) => {
      if (otherCommercialItem?.attachments) {
        otherCommercialItem.attachments = otherCommercialItem?.attachments.map((doc) => doc?._id || doc)
      }
    })
  }

  // There offer no need to be Submitted to backend

  for (const submissionDetail of offer.sourcing?.GCMaterialSubmissions || []) {
    if (submissionDetail?.raiser?._id) {
      submissionDetail.raiser = submissionDetail.raiser._id
    }
    if (submissionDetail?.requestor?._id) {
      submissionDetail.requestor = submissionDetail.requestor._id
    }

    submissionDetail.requestedDetails.forEach((requestorDetail) => {
      if (requestorDetail?.detail?.id) {
        requestorDetail.detail = requestorDetail.detail.id
      }
    })
  }

  return offer
}

export const formatOfferFromServer = (offer) => {
  const costBudgets = offer?.sourcing?.costBudgets || []

  const updatedCostBudgets = costBudgets.map((costBudget) => {
    const updates = {}

    if (costBudget?.firstTechnicalSelection?.isReference) {
      updates.firstTechnicalSelection = {
        ...costBudget.firstTechnicalSelection,
        vendor: 'reference',
      }
    }

    if (costBudget?.secondTechnicalSelection?.isReference) {
      updates.secondTechnicalSelection = {
        ...costBudget.secondTechnicalSelection,
        vendor: 'reference',
      }
    }

    if (costBudget?.finalSelection?.isReference) {
      updates.finalSelection = {
        ...costBudget.finalSelection,
        vendor: 'reference',
      }
    }

    return Object.keys(updates).length > 0 ? { ...costBudget, ...updates } : costBudget
  })

  const bookingProjectManager = offer?.booking?.projectManager
  const normalizedProjectManager = bookingProjectManager?._id ?? bookingProjectManager

  return {
    ...offer,
    booking: {
      ...offer.booking,
      projectManager: normalizedProjectManager,
    },
    sourcing: {
      ...offer.sourcing,
      costBudgets: updatedCostBudgets,
    },
  }
}
